import type { CSSProperties, LinariaClassName } from '@linaria/core';
import { cx } from '@linaria/core';
import { styled } from '@linaria/react';
import { ReactNode, memo } from 'react';
import { isTouchDevice } from '../../../utilities/browser';
import Tooltip, { TooltipProps } from '../../common/Tooltip';
import "./Container.linaria.module.css!=!./Container?./Container.linaria.module.css?css=H4sIAAAAAAAAA22Ny27CMBBF9/0KpG5gMcgR0Erux0SOXxnheFJ74gBR/70ikJY+lnPu0ZltrnTzPhaeYLTNERlUQB8B2XZZahvZprdlauh0m7+GLoML9hf9p6CHlCnJnnA+DeY+qLN8CP9h1+43vD96FGfh42mruKsrp5AHU1fClYiHVS5+chjYJmkS9ZBbZWhcF5XWAEGdbQLUFO98s1k6ZW9avtRpN1wOEwATBcYeGqWPPtEQjXwWQiy2znXE1yD8z2tyFBlGi75l+TLrn9tbKi1nAQAA"
const StyledContainer = /*#__PURE__*/styled('div')({
  name: "StyledContainer",
  class: "s1cbqwvt",
  propsAsIs: false
});
const shadowStyles = "atm_1faitud_10fvni5";
const tooltipStyles = "atm_v4dhtz_r3uz5 atm_cs_ni7l0g";

/** these label icons sitting right on a tile, so they ride closer than usual */
const TILE_TOOLTIP_GAP = 10;
export interface ContainerProps {
  children: ReactNode;
  shadow?: boolean;
  styleOverrides?: CSSProperties;
  title?: string;
  tooltipPlacement?: TooltipProps['placement'];
  className?: LinariaClassName;
  style?: CSSProperties;
}
const Container = memo((props: ContainerProps) => {
  const {
    tooltipPlacement = 'top',
    shadow = true,
    className,
    children,
    style,
    title
  } = props;
  if (isTouchDevice || !title) {
    return <StyledContainer aria-label={title} className={cx(shadow && shadowStyles, className)} data-testid="Container__Styled" style={style}>
                {children}
            </StyledContainer>;
  }
  return <Tooltip arrow className={tooltipStyles} gap={tooltipPlacement === 'top' ? TILE_TOOLTIP_GAP : undefined} placement={tooltipPlacement} title={title}>
            <StyledContainer aria-label={title} data-testid="Container__Styled" className={cx(shadow && shadowStyles)}>
                {children}
            </StyledContainer>
        </Tooltip>;
});
export default Container;
export { Container };